'use strict';

(function ($) {
  function getChangeOpenStatus($btn) {
    var $span = $btn.find('.glyphicon');
    var open = false;
    if ($span.hasClass('glyphicon-triangle-bottom')) {
      $span.removeClass('glyphicon-triangle-bottom');
      $span.addClass('glyphicon-triangle-right');
    } else {
      open = true;
      $span.addClass('glyphicon-triangle-bottom');
      $span.removeClass('glyphicon-triangle-right');
    }

    return open;
  }

  function getOpenStatus($btn) {
    var $span = $btn.find('.glyphicon');
    var open = false;
    if ($span.hasClass('glyphicon-triangle-bottom')) {
      open = true;
    }

    return open;
  }

  function doOpenChilds($parentRow, open) {
    var parentLevel = parseInt($parentRow.data('level'));
    var $childRow = $parentRow.next('tr');
    while ($childRow.length) {
      if (!$childRow.data('level')) {
        $childRow = $childRow.next('tr');
        continue;
      }

      if ($childRow.closest('thead').length) {
        $childRow = $childRow.closest('thead').next('tbody').find('tr:first');
        continue;
      }

      var childLevel = parseInt($childRow.data('level'));
      if (childLevel <= parentLevel) {
        //jsme na stejne, nebo vyssi urovni jako parent, koncime
        break;
      }

      if (childLevel === (parentLevel + 1)) {//primy potomek
        if (open) {
          $childRow.show();
        } else {
          $childRow.hide();
        }

        $childRow = $childRow.next('tr');
      }

      if (childLevel > (parentLevel + 1)) {//neprimy potomek
        var $childsParent = $childRow.prev('tr');
        var openChilds = getOpenStatus($childsParent);
        doOpenChilds($childsParent, open && openChilds);

        while (childLevel > (parentLevel + 1)) {
          if (!open) {
            $childRow.hide();
          }

          $childRow = $childRow.next('tr');
          childLevel = parseInt($childRow.data('level'));
        }
      }
    }
  }

  var methods = {
    init: function () {
      // options are not used
      // var opts = $.extend({}, $.fn.k2_sidebarToggle.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('tree-collapsible-init')) {
          return;
        }

        $this.addClass('tree-collapsible-init');

        $this.find('.collapse-childs').click(function () {
          var open = getChangeOpenStatus($(this));
          doOpenChilds($(this).closest('tr'), open);
          return false;
        });

        $this.find('.collapse-childs').dblclick(function () {
          return false;
        });

        $this.find('.collapse-childs-all').click(function () {
          var open = getChangeOpenStatus($(this));
          $(this).closest('table').find('tr[data-level="1"] .collapse-childs').each(function () {
            var rowOpen = getOpenStatus($(this));
            if ((open && !rowOpen) || (!open && rowOpen))  {
              $(this).click();
            }
          });

          return false;
        });

      });
    }
  };

  $.fn.k2_treeCollapsible = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_treeCollapsible');
    }

  };

  $.fn.k2_treeCollapsible.defaults = {};

})(jQuery);
